import base from './base';
import palette from "./palette";

const radius = base.shape.borderRadius as number;

const accordion = {
  MuiAccordion: {
    styleOverrides: {
      root: {
        border: '1px solid',
        borderColor: palette.grey[200],
        borderRadius: `${radius * 2}px !important`,
        boxShadow: 'none',
        '&::before': {
          display: 'none',
        },
      },
    },
  },
  MuiAccordionSummary: {
    styleOverrides: {
      root: {
        minHeight: 66,
        columnGap: '18px',
        '&.Mui-expanded': {
          minHeight: 66,
        },
        '&.Mui-focusVisible': {
          backgroundColor: 'transparent',
        },
      },
      content: {
        '&.Mui-expanded': {
          margin: '12px 0',
        },
      },
    },
  },
}

export default accordion;
